import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=e453da06&scoped=true&"
import script from "./Tab02.vue?vue&type=script&lang=js&"
export * from "./Tab02.vue?vue&type=script&lang=js&"
import style0 from "./Tab02.scss?vue&type=style&index=0&id=e453da06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e453da06",
  null
  
)

export default component.exports